// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-16588349648");
  window.gtag("event", "conversion", {
    send_to: ["AW-16588349648/kc-yCNrFhcEZENDB-OU9"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// `breeze-begin-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});
// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

function merchantInitiateCheckoutCustomCode(params) {
  // paste the snippet out here
  // GOOGLE ADS BEGIN CHECKOUT EVENT CODE START
  console.error("initiated", { params });
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-16588349648");
  window.gtag("event", "begin_checkout", {
    send_to: ["AW-16588349648/ht1VCKvShcEZENDB-OU9"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
  });
  // GOOGLE ADS BEGIN CHECKOUT EVENT CODE END
}
